(function ($) {
  window.addEventListener("DOMContentLoaded", () => {
    /**
     * Header main menu
     */
    const isDesktop = window.matchMedia('(min-width: 768px)').matches;
    const $menuItemDropdown = $('header .menu-items .sub-menu .dropdown-item');
    $menuItemDropdown.on('hover', function () {
      $menuItemDropdown.not($(this)).removeClass('show');
      if (isDesktop) {
        $(this).addClass('show');
      } else {
        $(this).toggleClass('show');
      }
    });
    $('header .menu-items .dropdown-toggle').on('click', function () {
      $('header .menu-items .sub-menu .dropdown-item').removeClass('show');
    });
    if (isDesktop) {
      $('header .menu-items .sub-menu >.list-item >.link-item').on('hover', function () {
        $('header .menu-items .sub-menu .dropdown-item').removeClass('show');
      });
    }
    if (!isDesktop) {
      $('.dropdown-menu').on('click', function (event) {
        event.stopPropagation();
      });
    }

    /**
     * Forms
     */

    const watchFormChanged = (event) => {
      const $e = $(event.currentTarget);
      $e.addClass('edited');
      $e.off('change, input', watchFormChanged);
    };
    $('.afgc-form').find('textarea, input, select').on('change, input', watchFormChanged);

    $('#toTop').on('click',function() {
      $('html, body').animate({scrollTop: 0}, 1000);
    });

    $('#toBottom').on('click',function() {
      var windowHeight = $(document).height();
      $('html, body').animate({scrollTop: windowHeight}, 1000);
    });
  });


})(jQuery);




